module.exports = __webpack_public_path__ + "static/media/archive.6aee118d.svg";